import {
  Box,
  Button,
  Flex,
  Skeleton,
  Table,
  TableContainer,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import Layout from "../components/Layout";
import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import client from "../utils/client";
import SponsorItem from "../components/SponsorItem";
import { useNavigate } from "react-router-dom";
import AdminPage from "../components/AdminPage";

const AllSponsors = () => {
  const [isLoadingPage, setIsLoadingPage] = useState(true);
  const [sponsorItems, setSponsorItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState([]);

  const auth = useAuth();
  const navigate = useNavigate();

  const handleDelete = async (sponsorId) => {
    await client.delete(`/sponsors/${sponsorId}`);
    setSponsorItems(sponsorItems.filter((sponsor) => sponsor.sponsorId !== sponsorId));
  };

  useEffect(() => {
    setIsLoadingPage(true);
    const request = async () => {
      const response = await client.get(`/sponsors?page=${currentPage}`);
      setSponsorItems(response.data.sponsorItems);
      setCurrentPage(response.data.currentPage);
      setTotalPages(
        Array.from({ length: response.data.totalPages }, (_, index) => index + 1)
      );
    };
    request().then(() => setIsLoadingPage(false));
  }, [currentPage]);

  return (
    <Layout>
      {auth?.user.type === process.env.REACT_APP_ADMINISTRATOR ? (
        <AdminPage
          title="Gerenciar Patrocinadores"
          subtitle={`${sponsorItems.length} patrocinadores`}
          action={() => navigate("/createSponsor")}
          actionLabel="+ Novo Patrocinador"
        >
          <Skeleton isLoaded={!isLoadingPage}>
            <TableContainer>
              <Table size="sm" variant="striped" colorScheme="green" fontSize="0.82rem">
                <Thead bg="green.50">
                  <Tr>
                    <Th fontSize="0.72rem" maxW="180px">Nome</Th>
                    <Th fontSize="0.72rem">Tipo</Th>
                    <Th fontSize="0.72rem">Término</Th>
                    <Th fontSize="0.72rem" maxW="160px">URL</Th>
                    <Th fontSize="0.72rem">Ações</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {sponsorItems[0] &&
                    sponsorItems.map((sponsor) => (
                      <SponsorItem key={sponsor.sponsorId} sponsor={sponsor} onDelete={handleDelete} />
                    ))}
                </Tbody>
              </Table>
            </TableContainer>

            {totalPages.length > 1 && (
              <Flex gap={2} py={4} px={5} alignItems="center" justifyContent="center">
                {totalPages.map((page) =>
                  page === currentPage ? (
                    <Box key={page} w="32px" h="32px" borderRadius="50%" bg="green.500" color="white" display="flex" alignItems="center" justifyContent="center" fontWeight={700} fontSize="0.85rem">{page}</Box>
                  ) : (
                    <Button key={page} colorScheme="green" size="sm" variant="outline" borderRadius="50%" w="32px" h="32px" p={0} onClick={() => setCurrentPage(page)}>{page}</Button>
                  )
                )}
              </Flex>
            )}
          </Skeleton>
        </AdminPage>
      ) : (
        <Box textAlign="center" py={20} color="gray.400">
          <Text fontSize="1.2rem">Acesso não autorizado.</Text>
        </Box>
      )}
    </Layout>
  );
};
export default AllSponsors;
